import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ProductViewDataService } from  './../../shared-postlogin/services/product-view-data.service';
import { ApiGatewayHelperService } from './../../app/services/apigateway-helper.service';
import { AuthService } from '../../app/services/auth.service';
import { AppHelperService } from 'modules/app/services/app-helper.service';


@Injectable()
export class AssignmentViewResolverService  {
    constructor(private authService: AuthService,
        private productViewDataService: ProductViewDataService,
        private appHelperService: AppHelperService,
        private apiGatewayHelperService : ApiGatewayHelperService) { }
    
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.apiGatewayHelperService.setSpaceId(route.params.spaceid);
        let productCode = route.params.productcode;
        let userData = this.authService.getUserData();
        let classId = route.params.classid;
        let assignmentDataRequired = true;
        let ruleRequired: any = 'allRulesForCreateAssignments';
        let ltik;
        let assignmentId;
        let isEditAssignment = false;
        if(state.url.indexOf('/ltideeplinking/') > -1) {
            ruleRequired = false;
            ltik = route.queryParams.ltik;
        }
        if (state.url.indexOf('/edit-assignment/') > -1 && route.params.assignmentid) {
            isEditAssignment = true;
            assignmentId = route.params.assignmentid;
        }
        // if (route.params.productcode) {
            return this.productViewDataService.fetchAndStoreProductViewData({productCode, classId, assignmentId}, assignmentDataRequired, false, ruleRequired, false, ltik, isEditAssignment).toPromise().then((productData: any)=> {

                if (productData && productData.success === false) {
                    this.appHelperService.showLoaderAndNavigateToDashboard(userData);
                    return;
                }
                // NEMO-6677 : navigate away to dashboard as the product is suppressed.
                let bundleDetails = productData['bundleDetails'];
                let product = bundleDetails && bundleDetails.products && bundleDetails.products.find((bundle) => bundle['dls-product'] && bundle['dls-product'].code === productCode);
                let suppressedAssignment = this.productViewDataService.isProductSuppressed(product, 'hide-assignments', route.params.spaceid);
                if (suppressedAssignment) {
                    this.appHelperService.navigateToDashboardApp([]);
                }

                return {
                    'userProfileData': userData,
                    'productData': productData
                }
            });
        // }            
    }
}